import { GoogleOAuthProvider } from '@react-oauth/google';
import type { ReactNode } from 'react';

import { config } from '@/config/config';
import { useTrackEvent } from '@/lib/posthog/hooks/useTrackEvent';

/**
 * Google's OAuth provider for the auth pages. Reports when Google's sign-in
 * script fails to load (blocked by an extension, network or firewall), because
 * the button then never renders. In-app browsers load it fine, so they are
 * covered by the `inAppBrowser` property on the click events instead.
 *
 * `locale` loads Google's script in English, so the button and One Tap don't
 * follow the browser's language. The provider is the only place to set it.
 */
export const GoogleAuthProvider = ({ children }: { children: ReactNode }) => {
  const trackEvent = useTrackEvent();

  return (
    <GoogleOAuthProvider
      clientId={config.external.googleClientId}
      locale="en"
      onScriptLoadError={() => trackEvent('googleSignInUnavailable')}
    >
      {children}
    </GoogleOAuthProvider>
  );
};
